export default __webpack_public_path__ + "static/media/product18_sportsshoe.e67d3777.webp";